// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import en from './locales/en.json';
import ms from './locales/ms.json';
import id from './locales/id.json'; // Assuming Indonesian uses the same file as Malay for now
import zh from './locales/zh.json';
import hn from './locales/hn.json';
import ct from './locales/ct.json';
import hk from './locales/hk.json';
import tc from './locales/tc.json';
import ta from './locales/ta.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import es from './locales/es.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import th from './locales/th.json';
import vi from './locales/vi.json';
import ar from './locales/ar.json';
import hi from './locales/hi.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import it from './locales/it.json';

const resources = {
  en: { translation: en },
  ms: { translation: ms },
  id: { translation: id }, // Assuming Indonesian uses the same file as Malay for now
  zh: { translation: zh },
  hn: { translation: hn }, // Assuming Hokkien uses the same file as Chinese for now
  ct: { translation: ct }, // Assuming Cantonese uses the same file as Chinese for now
  hk: { translation: hk }, // Assuming Haka uses the same file as Chinese for now
  tc: { translation: tc }, // Assuming Teochew uses the same file
  ta: { translation: ta },
  fr: { translation: fr },
  de: { translation: de },
  es: { translation: es },
  ja: { translation: ja },
  ko: { translation: ko },
  th: { translation: th },
  vi: { translation: vi },
  ar: { translation: ar },
  hi: { translation: hi },
  pt: { translation: pt },
  ru: { translation: ru },
  it: { translation: it },
};

// Language mapping for your settings
export const languageMapping = {
  'English': 'en',
  'Malay': 'ms', 
  'Indonesia': 'id',
  'Chinese': 'zh',
  'Hokkien': 'hn',
  'Cantonese': 'ct',
  'Hakka': 'hk',
  'Teochew': 'tc',
  'Tamil': 'ta',
  'French': 'fr',
  'German': 'de',
  'Spanish': 'es',
  'Japanese': 'ja',
  'Korean': 'ko',
  'Thai': 'th',
  'Vietnamese': 'vi',
  'Arabic': 'ar',
  'Hindi': 'hi',
  'Portuguese': 'pt',
  'Russian': 'ru',
  'Italian': 'it',
};

export const reverseLanguageMapping = Object.fromEntries(
  Object.entries(languageMapping).map(([key, value]) => [value, key])
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: import.meta.env.NODE_ENV === 'development',    
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    react: {
      useSuspense: false, // Prevents loading issues
    }
  });

// Function to change language programmatically
export const changeLanguage = (languageName) => {
  const languageCode = languageMapping[languageName] || 'en';
  i18n.changeLanguage(languageCode);
};

export default i18n;